import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=23163cda&scoped=true"
import script from "./LogoImage.vue?vue&type=script&lang=js"
export * from "./LogoImage.vue?vue&type=script&lang=js"
import style0 from "./LogoImage.vue?vue&type=style&index=0&id=23163cda&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23163cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23163cda')) {
      api.createRecord('23163cda', component.options)
    } else {
      api.reload('23163cda', component.options)
    }
    module.hot.accept("./LogoImage.vue?vue&type=template&id=23163cda&scoped=true", function () {
      api.rerender('23163cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/lib/components/LogoImage.vue"
export default component.exports